export const APPROVAL_WORKFLOW_API_PATHS = {
  GET_APPROVAL_WORKFLOWS: "v1/organization/{0}/approval-workflow/",
  GET_APPROVAL_WORKFLOW_DETAIL:
    "v1/organization/{0}/approval-workflow/{1}/",
  CREATE_OR_UPDATE_APPROVAL_WORKFLOW:
    "v1/organization/{0}/approval-workflow/create-or-update/",
  PATCH_APPROVAL_WORKFLOW_STATUS:
    "v1/organization/{0}/approval-workflow/{1}/status/",
  DELETE_APPROVAL_WORKFLOW:
    "v1/organization/{0}/approval-workflow/{1}/delete",
};
